import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var shareButtons = {
  name: "1a7fyhf",
  styles: "display:inline-block;text-align:center;"
};
export var shareButton = /*#__PURE__*/css("display:inline-block;width:32px;height:32px;cursor:pointer;border:0;outline:0;background-color:", colors.neutral.subdued.default, ";border-radius:100px;text-align:center;padding:0;:not(:first-of-type){margin-left:16px;}.domain-icon{color:", colors.neutral.heavy.default, ";}");